import { PermanentFilterStorage } from './permanent-filter-storage';

export class WaterfallFilterPermanentStorage extends PermanentFilterStorage {
  /**
   * @private
   * @param {string} featureName - feature name
   * @return {string} - return storage key
   */
  getStorageKey(featureName) {
    return `WebApp.CampaignUI.${featureName}`;
  }
}
